/**
 * Filter Hook - Incoming
 *
 * Filters messages by predicate. Returns false aborts pipeline.
 */

import { BaseHook } from '../base/BaseHook';
import type { IPipelineContext, HookResult } from '../../types';

export type FilterPredicate = (context: IPipelineContext) => boolean;

export class FilterHook extends BaseHook {
  readonly name = 'FilterHook';

  readonly priority = 50;

  private predicate: FilterPredicate;

  constructor(predicate: FilterPredicate) {
    super();
    this.predicate = predicate;
  }

  async execute(context: IPipelineContext): Promise<HookResult> {
    try {
      const result = this.predicate(context);
      if (!result) {
        return this.abort('Filter predicate rejected message');
      }
      return this.continue();
    } catch (error) {
      return this.error(`Filter error: ${error instanceof Error ? error.message : String(error)}`);
    }
  }
}
